module.exports = __webpack_public_path__ + "media/components/publish/images/text_alert-b001de7d5cbd729663d9cc924664db41.png";